import { RootState } from "store/store";

export const selectPermissions = (state: RootState) => state.permissions;
